
import React from 'react';
export default function Home() {
  return <div className="container py-5"><h1>Awards</h1></div>;
}
